import { SvgIcon, SvgIconProps } from '@mui/material';

export function LeadingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.75 5.96119C17.61 5.41119 17.06 5.09119 16.51 5.21119C14.13 5.74119 11.48 5.97119 9.00002 5.97119C6.52002 5.97119 3.87002 5.74119 1.49002 5.21119C0.940024 5.09119 0.390024 5.41119 0.250024 5.96119C0.110024 6.52119 0.450024 7.09119 1.00002 7.22119C2.61002 7.58119 4.35002 7.83119 6.00002 7.97119V19.9712C6.00002 20.5212 6.45002 20.9712 7.00002 20.9712C7.55002 20.9712 8.00002 20.5212 8.00002 19.9712V14.9712H10V19.9712C10 20.5212 10.45 20.9712 11 20.9712C11.55 20.9712 12 20.5212 12 19.9712V7.97119C13.65 7.83119 15.39 7.58119 16.99 7.22119C17.55 7.09119 17.89 6.52119 17.75 5.96119ZM9.00002 4.97119C10.1 4.97119 11 4.07119 11 2.97119C11 1.87119 10.1 0.971191 9.00002 0.971191C7.90002 0.971191 7.00002 1.87119 7.00002 2.97119C7.00002 4.07119 7.90002 4.97119 9.00002 4.97119Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}
